<template>
  <div>
    <div>
      <v-simple-table dense>
        <template v-slot:default>
          <tbody>
            <TooltipTR section="section200" field="OBJ_COO" :label="$t('centered-coordinates')">
              <div>{{ $t("centered-coordinates") }}</div>
              <div>{{ objectItem.OBJ_COO_X }} - {{ objectItem.OBJ_COO_Y }}</div>
            </TooltipTR>
            <TooltipTR section="section200" field="OBJ_TYP" :label="$t('object-type')">
              <div>{{ $t("object-type") }}</div>
              <div>{{ objectItem.OBJ_TYP }}</div>
            </TooltipTR>
            <TooltipTR section="section200" field="OBJ_FLO" :label="$t('number-of-floors')">
              <div>{{ $t("number-of-floors") }}</div>
              <div>{{ objectItem.OBJ_FLO }}</div>
            </TooltipTR>
            <TooltipTR section="section200" field="OBJ_UNI" :label="$t('number-of-units')">
              <div>{{ $t("number-of-units") }}</div>
              <div>{{ objectItem.OBJ_UNI }}</div>
            </TooltipTR>
            <TooltipTR section="section200" field="HEIGHT" :label="$t('height')">
              <div>{{ $t("height") }}</div>
              <div>{{ objectItem.HEIGHT ? objectItem.HEIGHT + " m" : "-" }}</div>
            </TooltipTR>
            <TooltipTR section="section200" field="OBJ_JOB" :label="$t('year-of-construction')">
              <div>
                <b>{{ $t("year-of-construction") }}</b>
              </div>
              <div>
                <b>{{ objectItem.OBJ_JOB }}</b>
              </div>
            </TooltipTR>
            <TooltipTR section="section200" field="OBJ_POB" :label="$t('construction-period')">
              <div>{{ $t("construction-period") }}</div>
              <div>{{ objectItem.OBJ_POB }}</div>
            </TooltipTR>
            <TooltipTR section="section200" field="OBJ_PRO" :label="$t('listed')">
              <div>{{ $t("listed") }} <span v-if="objectItem.OBJ_PRO_LABEL == 'Y'" style="color: red; font-size: 20px; line-height: 1">&#9888;</span></div>
              <div>{{ objectItem.OBJ_PRO }}</div>
            </TooltipTR>
            <TooltipTR section="section200" field="OBJ_MUN" :label="$t('municipality')">
              <div>{{ $t("municipality") }}</div>
              <div>{{ objectItem.OBJ_MUN }}</div>
            </TooltipTR>
            <TooltipTR section="section200" field="OBJ_ZIP" :label="$t('postal-code')">
              <div>{{ $t("postal-code") }}</div>
              <div>{{ objectItem.OBJ_ZIP }}</div>
            </TooltipTR>
            <TooltipTR section="section200" field="OBJ_STR" :label="$t('street')">
              <div>{{ $t("street") }}</div>
              <div>{{ objectItem.OBJ_STR }}</div>
            </TooltipTR>
            <TooltipTR section="section200" field="OBJ_STN" :label="$t('number')">
              <div>{{ $t("number") }}</div>
              <div>{{ objectItem.OBJ_STN }}</div>
            </TooltipTR>
          </tbody>
        </template>
      </v-simple-table>
    </div>
  </div>
</template>

<script lang="ts">
import {Component, Prop, Vue} from "vue-property-decorator"
import TooltipTR from "./TooltipText.vue"

@Component({
  components: {TooltipTR},
})
export default class ViewPlotDetails200 extends Vue {
  @Prop()
  plotItem

  @Prop()
  objectItem
}
</script>
